import React from 'react';

const LoadingScreen = ({ message = "Loading..." }) => {
  return (
    <div className="loading-container">
      <div style={{ textAlign: 'center' }}>
        <div className="loading-spinner"></div>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;